import { createFileRoute } from "@tanstack/react-router";
import { MyPresetsScreen } from "@/features/presets/components/MyPresetsScreen";

export const Route = createFileRoute("/_authenticated/presets/mine")({
  staticData: { access: "account" },
  head: () => ({ meta: [{ title: "My presets · Pax.co" }] }),
  component: MyPresetsScreen,
});
